import isBefore from 'date-fns/isBefore';

interface DatasetLike {
  updated_at: string;
}

export const getOldestDataset = <T extends DatasetLike>(
  datasets: T[],
): T | null => {
  if (datasets.length === 0) {
    return null;
  }

  return datasets.reduce((oldest, current) =>
    isBefore(new Date(current.updated_at), new Date(oldest.updated_at))
      ? current
      : oldest,
  );
};
